<script>
   /*********************************************************************/
   /* Modal                                                             */
   /* --------------------                                              */
   /* dialog over the page; the caller closes it by unmounting it       */
   /*********************************************************************/

	import { fade } from 'svelte/transition';

   let {
      closeModal,
      children,
      isDark = false,
   } = $props();

   // a modal dialog: the browser makes the page behind inert, so neither the pointer nor Tab
   // reaches it (a fixed div stopped the pointer only). opening moves focus into the dialog, and
   // the element that had it gets it back when the dialog goes, if it is still on the page,
   // without scrolling to it. Svelte has removed the dialog by this teardown, which ends the
   // inert page; close() covers the other order, as an inert page takes no focus
   let dlg;
   $effect(() => {
      const d = dlg, opener = document.activeElement;
      d.showModal();
      return () => {
         if (d.open) d.close();
         if (opener?.isConnected) opener.focus({preventScroll: true});
      };
   });

   // Escape: the browser would close the dialog itself; the caller unmounts it instead, as every
   // close does (a closed dialog left mounted would still show, '.drop' sets its display)
   function cancel(e) {
      e.preventDefault();
      closeModal();
   }
</script>

<dialog class="drop" class:isdark={isDark} bind:this={dlg} in:fade oncancel={cancel}>
   <div class="modal" >
      <div class="header">
         <!-- tabindex="0": Safari's default Tab skips a button without one -->
         <button class="close-button" onclick={closeModal} aria-label="close"
            tabindex="0">✕</button>
      </div>

      <div class="body">
      {@render children()}
      </div>

   </div>
</dialog>

<style>
   .drop {
      inset: 0;
      width: 100%;
      height: 100%;
      max-width: none;
      max-height: none;
      margin: 0;
      padding: 0;
      border: none;
      color: inherit;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #000000a0;
      transition: background-color 0.3s ease;
   }

   .drop::backdrop {
      background: transparent;
   }


   .modal {
      border-radius: 0.5rem;
      background-color: white;
      display: grid;
      grid-template-areas:
         "header"
         "body";
      grid-template-rows: 30px 1fr;
      width: auto;
      height: auto;

      width: auto;
      height: auto;
      border-radius: .25rem;
   }

   .body {
      grid-area: body;
      box-sizing: border-box;
      padding: 0 1em 0.5em 1em;
      width: 100%;
      height: 100%;
   }

   .header {
      grid-area: header;
   }

   .close-button {
      cursor: pointer;
      border: none;
      box-shadow: none;
      background: transparent;
      font-size: inherit;
      font-weight: bold;
      color: #f8ebc5;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      background-color: #9ea0a2;
      float: right;
      text-align: center;
      padding: 0;
      line-height: 20px;
      font-size: 12px;
      margin: 5px;
   }

   .close-button:hover {
      background-color: #4e5052;
   }

   .isdark, .isdark .header, .isdark .body {
      background-color: #606060;
   }

   .isdark .close-button {
      color: #433201;
      background-color: #c2be9b;
   }

   .isdark .close-button:hover {
      background-color: #f0f674;
   }


</style>